// variant-from-image.js — Tinker theme compatible
(function () {
  function init() {
    const mediaGallery = document.querySelector('media-gallery');
    if (!mediaGallery) return;

    const productDataEl = document.getElementById('ProductJSON');
    if (!productDataEl) return;

    let product;
    try {
      product = JSON.parse(productDataEl.textContent);
    } catch (e) {
      console.warn('[variant-from-image] Error parsing ProductJSON', e);
      return;
    }

    // Map: featured_media.id → variant
    const mediaToVariant = {};
    product.variants.forEach((variant) => {
      if (variant.featured_media) {
        mediaToVariant[variant.featured_media.id] = variant;
      }
    });

    mediaGallery.addEventListener('click', (e) => {
      const mediaEl = e.target.closest('[data-media-id]');
      if (!mediaEl) return;

      const mediaId = parseInt(mediaEl.dataset.mediaId, 10);
      const matchedVariant = mediaToVariant[mediaId];
      if (!matchedVariant) return;

      const variantPicker = document.querySelector('variant-picker');
      if (!variantPicker) return;

      // For each option of the matched variant, click the corresponding radio
      matchedVariant.options.forEach((optionValue, index) => {
        // Find the radio input that matches this option value
        // Tinker uses data-input-id="position-index" and value = option text
        const fieldsets = variantPicker.querySelectorAll('fieldset');
        const fieldset = fieldsets[index];
        if (!fieldset) return;

        // Try radio input
        const radios = fieldset.querySelectorAll('input[type="radio"]');
        radios.forEach((radio) => {
          if (radio.value === optionValue && !radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });

        // Try select (dropdown style)
        const select = fieldset.querySelector('select.variant-option__select');
        if (select && select.value !== optionValue) {
          select.value = optionValue;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  // Wait for variant-picker to be defined before running
  if (customElements.get('variant-picker')) {
    init();
  } else {
    customElements.whenDefined('variant-picker').then(init);
  }
})();
